import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import PendingsPanel from "./PendingsPanel"; // panel admin que muestra "Reservas por aprobar"
import { db as defaultDb, auth as defaultAuth } from "./firebase";

/**
 * PendingReservationsRoute
 * URL: /admin/pending-reservations?businessId=...
 * Renders the admin PendingsPanel (reservas por aprobar) for the provided businessId.
 */
export default function PendingReservationsRoute({ renderMainMenu, db = defaultDb, user = null }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const businessId = searchParams.get("businessId") || null;

  useEffect(() => {
    try {
      console.debug("[PendingReservationsRoute] mounted, businessId:", businessId, "location.search:", window.location.search, "history.state:", history.state);
    } catch (e) {}
  }, [businessId]);

  return (
    <div>
      {typeof renderMainMenu === "function" ? renderMainMenu({ headerOnly: true }) : null}
      <div className="max-w-7xl mx-auto px-6 py-6">
        <div style={{ marginBottom: 12 }}>
          <button
            onClick={() => {
              if (businessId) {
                navigate(`/admin-booking-calendar/${businessId}`);
              } else {
                navigate(-1);
              }
            }}
            style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #e6eef6", background: "#fff" }}
          >
            ← Volver
          </button>
        </div>

        <div style={{ marginBottom: 12, padding: 12, borderRadius: 8, background: "#fff", boxShadow: "0 1px 2px rgba(0,0,0,0.04)" }}>
          <strong>Diagnóstico PendingReservationsRoute</strong>
          <div>businessId (desde query): {businessId || "<none>"}</div>
          <div>location.search: {window.location.search}</div>
        </div>

        <div>
          {/* Render admin pendings panel (reservas por aprobar) */}
          <PendingsPanel db={db} businessId={businessId} user={user || defaultAuth.currentUser} isAdmin={true} onBack={() => navigate(-1)} />
        </div>
      </div>
    </div>
  );
}